import axios from "axios"
import cloudFunctionsURL, { dataRoomURL } from "../config/cloudFunctionsURL"
import logApiURL from "../config/logApiURL"
import logger from "../services/logger"

const api = axios.create({
  baseURL: cloudFunctionsURL(),
})

export const dataRoomApi = axios.create({
  baseURL: dataRoomURL(),
})

export const apiService = axios.create({
  baseURL: logApiURL(),
})

export function setAuthToken(token) {
  api.defaults.headers.common["Authorization"] = token
  dataRoomApi.defaults.headers.common["Authorization"] = token
  apiService.defaults.headers.common["Authorization"] = token
}

const handleErrorResponse = (error) => {
  if (error.response) {
    logger.error(`API Error: ${error.response.status}`, { statusCode: error.response.status })
    if (error.response.status === 401) {
      window.location.href = "/"
    }
  }
  return Promise.reject(error)
}

api.interceptors.response.use((response) => response, handleErrorResponse)
dataRoomApi.interceptors.response.use((response) => response, handleErrorResponse)
apiService.interceptors.response.use((response) => response, handleErrorResponse)

export default api
